import React, { useState } from 'react'

import InstagramWithFacebookAuthorisationButton from '../../components/authorise/platforms/InstagramWithFacebookAuthorisationButton'
import { AccountOnboardingLayout } from '../../containers/AccountOnboardingLayout'

/**
 * This page is used to add an Instagram account to Arwen. This uses the legacy auth technique whereby an Instagram profile must be connected to a Facebook Business page.
 */
function NewFacebookAccountFacebookAuthPage() {
    const [isBusinessProfile, setIsBusinessProfile] = useState<boolean>(false)
    const [isLinkedToFacebookPage, setIsLinkedToFacebookPage] = useState<boolean>(false)

    const handleBusinessProfileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setIsBusinessProfile(event.target.checked)
    }

    const handleLinkedToFacebookPageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setIsLinkedToFacebookPage(event.target.checked)
    }

    // We block the button using a div with a higher z-index than the button, unless both
    // checkboxes are checked.
    const areBothChecked = isBusinessProfile && isLinkedToFacebookPage

    return (
        <AccountOnboardingLayout title="Add Instagram profile">
            <p>
                Click below to add an Instagram profile to Arwen. Use this option if you have a
                Facebook page connected to your Instagram profile, or need to run ads.
            </p>
            <p>
                <iframe
                    src="https://www.youtube.com/embed/_Ulinr3XXZY"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                    className="md:w-[560px] md:h-[315px]"
                ></iframe>
            </p>
            <div className="mb-2">
                <label className="flex items-center space-x-2">
                    <input
                        type="checkbox"
                        checked={isBusinessProfile}
                        onChange={handleBusinessProfileChange}
                        className="form-checkbox rounded shadow"
                    />
                    <span>My account is a business profile</span>
                </label>
            </div>
            <div className="mb-4">
                <label className="flex items-center space-x-2">
                    <input
                        type="checkbox"
                        checked={isLinkedToFacebookPage}
                        onChange={handleLinkedToFacebookPageChange}
                        className="form-checkbox rounded shadow"
                    />
                    <span>My account is linked to a Facebook page</span>
                </label>
            </div>
            <div className="relative">
                {!areBothChecked && (
                    <div className="absolute inset-0 bg-white opacity-50 cursor-not-allowed z-10"></div>
                )}
                <InstagramWithFacebookAuthorisationButton />
            </div>
        </AccountOnboardingLayout>
    )
}

export default NewFacebookAccountFacebookAuthPage
